//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    lang: {
      type: String,
      default: 'th'
    },
    currentTem: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};